var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 2.07343C10.6437 2.18652 9.93159 2.43029 8.83772 2.80472L8.26491 3.0008C5.25832 4.02996 3.75503 4.54455 3.37752 5.08242C3.00825 5.60854 3.00018 7.14975 3 10.2094L11.25 7.45944V2.07343Z",
    fill: "url(#paint0_linear_6468_4525)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 9.04058L3 11.7906V11.9914C3 17.6294 7.23896 20.3655 9.89856 21.5273C10.4093 21.7504 10.7392 21.8945 11.25 21.9597V9.04058Z",
    fill: "url(#paint1_linear_6468_4525)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 21.9597V9.04058L21 11.7906V11.9914C21 17.6294 16.761 20.3655 14.1014 21.5273C13.5907 21.7504 13.2608 21.8945 12.75 21.9597Z",
    fill: "url(#paint2_linear_6468_4525)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.45944V2.07343C13.3563 2.18652 14.0684 2.43029 15.1623 2.80473L15.7351 3.0008C18.7417 4.02996 20.245 4.54455 20.6225 5.08242C20.9918 5.60854 20.9998 7.14975 21 10.2094L12.75 7.45944Z",
    fill: "url(#paint3_linear_6468_4525)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6468_4525",
    x1: 13.1674,
    y1: 2.07343,
    x2: 13.1674,
    y2: 21.9597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6468_4525",
    x1: 13.1674,
    y1: 2.07343,
    x2: 13.1674,
    y2: 21.9597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6468_4525",
    x1: 13.1674,
    y1: 2.07343,
    x2: 13.1674,
    y2: 21.9597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6468_4525",
    x1: 13.1674,
    y1: 2.07343,
    x2: 13.1674,
    y2: 21.9597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.b82712a6754670e20e74deebf2621279.svg";
export { ForwardRef as ReactComponent };